import type { ContentPage } from "@/lib/content/types";

// MIGRATED (Phase 3): faithful port of the former hand-coded
// components/gitbiz/solutions/bpo-kpo/index.jsx (rendered by the deleted
// app/(homes)/(hrms)/hrms-software/solutions/bpo-kpo/page.jsx) onto the content
// engine (template "solution"). Copy, images, links match the original.
// SEO comes from GeneralPageSEOMetadata.json via <SEO> (its "bpo-kpo" entry).

export const bpoKpo: ContentPage = {
  slug: "solutions/bpo-kpo",
  template: "solution",
  seo: {
    title: "BPO/KPO Software Solutions for Efficiency | GetBiz Solutions",
    description: "GetBiz Solutions supports BPO/KPO firms with tools for data management, task automation, and seamless customer service processes.",
    keywords: [
      "BPO software",
      "KPO solutions",
      "data management",
      "task automation",
      "BPO management tools",
      "customer service software",
      "business process outsourcing",
      "process automation",
    ],
    ogImage: "/assets/data/seoimages/bpo-kpo.webp",
  },
  solution: {
    hero: {
      title: "Enhance Operational Efficiency for BPO/KPO Firms",
      description: "Automate workflow, customer service, and reporting to scale operations.",
      image: "/assets/images/img/bpo_kpo_solutions.webp",
      imageAlt: "it_solutions",
      bgImage: "/assets/images/full-width-images/section-bg-10.jpg",
      ctaPrimary: { label: "Start 15 Days Trial", href: "/pricing/" },
      ctaSecondary: { label: "Book A Demo", href: "/book-demo/" },
    },
    servicesTitle: "Enhancing Efficiency in BPO/KPO Operations",
    services: [
      { title: "Task Automation", description: "Automatically assign, track, and prioritize tasks to ensure projects stay on track and meet deadlines." },
      { title: "Customer Support", description: "Manage customer inquiries and tickets efficiently through automation, improving service levels and response times." },
      { title: "Employee Performance Tracking", description: "Automate performance tracking to gain insights into employee productivity and areas of improvement." },
      { title: "Client Onboarding", description: "Streamline the client onboarding process, making it quicker and more efficient for both parties." },
      { title: "Data Reporting", description: "Automate the generation of detailed reports, ensuring accuracy and saving time on manual data entry." },
      { title: "Time & Attendance", description: "Automatically track employee attendance and work hours, ensuring compliance with labor laws and policies." },
    ],
    ctaStrip: {
      description: "Book a personalized demo to see how our solutions can transform your business and boost your efficiency.",
      button: { label: "Book A Demo", href: "/book-demo/" },
    },
    faqDescription: "Understand how GetBiz Solutions empowers BPO/KPO businesses. Our FAQs explain tools for managing high volumes of data, automating routine tasks, and providing exceptional service. Discover how our platform helps you streamline operations, improve client satisfaction, and manage large teams efficiently with real-time data insights and process automation.",
    metaKey: "bpo-kpo",
  },
  sections: [],
};
